import * as React from "react";
import "./ButtonExpand.styl";
import Context from "./Context";
import CommentModel from "../models/CommentModel";

export default class ButtonExpand extends React.Component<{
    parent: number;
    count: number;
}> {

    public render(): React.ReactNode {
        return (
            <Context.Consumer>
                {({translate, dispatch}) => (
                    <div className="Discussion-ButtonExpand-Root" onClick={() => {
                        dispatch("expand", this.props.parent);
                    }}>
                        {translate("BUTTON_EXPAND", {count: this.props.count.toString()})}

                    </div>
                )}
            </Context.Consumer>
        )
    }

}